import React from 'react';
import { Button, Card, CardHeader, CardContent, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Swal from 'sweetalert2';
import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import RTabla from '../../componentes/tabla';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage, getUniqueKey } from '../../auxiliares/funciones';
import Alta from './alta';

export default function Trabajadores(props) {
  const [lista, setLista] = React.useState([]);
  const [cargado, setCargado] = React.useState(false);
  const [key, setKey] = React.useState(getUniqueKey());

  const campos = ['nombre', 'puesto', 'fechaAlta', 'fechaBaja', 'estado'];
  const cabecera = ['Nombre', 'Función', 'Fecha Alta / Reactivación', 'Fecha Baja', 'Estado'];
  const usuario = workWithLocalStorage('get', 'usuario', null);

  React.useEffect(() => {
    if (!cargado) {
      const bodyJson = JSON.stringify(buildBody(usuario.token, {}));
      fetch(`${CONFIG.api}list/trabajadores`, {
        method: 'POST',
        body: bodyJson,
        headers: { 'Content-Type': 'application/json' }
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.error === 0 && !isEmpty(result.data)) {
            setLista(result.data);
          }
          setKey(getUniqueKey());
          if (props.showLoader) props.showLoader(false);
          setCargado(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargado]);

  const altaTrabajador = (objeto) => {
    if (objeto !== null) {
      if (props.setTabs) {
        props.setTabs({
          nombre: `Editar Trabajador #${objeto.id}`,
          componente: Alta,
          params: { id: objeto.id },
          visible: true
        });
      }
    } else if (props.setTabs) {
      props.setTabs({
        nombre: 'Alta Trabajador',
        componente: Alta,
        params: {},
        visible: true
      });
    }
  };

  const Actualiza = () => {
    if (props.showLoader) props.showLoader(true);
    setCargado(false);
  };

  const validaBorrar = (obj) => obj.activo === 1;
  const validaActivar = (obj) => obj.activo !== 1;

  const Activar = (obj) => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'trabajador',
      activo: 1,
      id: obj.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Trabajador/a activado!';
        if (result.error === 0) {
          setLista([]);
          setCargado(false);
        } else {
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const Borrar = (obj) => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'trabajador',
      activo: 0,
      id: obj.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Trabajador/a desactivado!';
        if (result.error === 0) {
          setLista([]);
          setCargado(false);
        } else {
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const theme = useTheme();
  const acciones = [
    {
      color: undefined,
      nombre: 'Ver',
      icono: <Iconify icon="eva:edit-fill" style={{ fontSize: '20px' }} />,
      funcion: altaTrabajador,
      estilo: { backgroundColor: theme.palette.gradients.primary, color: theme.palette.common.white },
      condition: null
    },
    {
      color: 'error',
      nombre: 'Borrar',
      icono: <i />,
      funcion: Borrar,
      estilo: {},
      condition: validaBorrar
    },
    {
      color: 'warning',
      nombre: 'Activar',
      icono: <i />,
      funcion: Activar,
      estilo: {},
      condition: validaActivar
    }
  ];

  return (
    <Page title="Trabajadores" key={lista.length}>
      <Card sx={{ maxWidth: '100% !important' }}>
        <CardHeader
          action={
            <>
              <Button
                variant="contained"
                color="primary"
                sx={{ color: 'white', marginRight: '15px' }}
                to="#"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => altaTrabajador(null)}
              >
                Alta
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ color: 'white' }}
                to="#"
                startIcon={<Iconify icon="eva:refresh-fill" />}
                onClick={() => Actualiza()}
              >
                Actualizar
              </Button>
            </>
          }
          title="Trabajadores"
        />
        <Divider style={{ margin: '15px' }} />
        <CardContent>
          <RTabla key={key} lista={lista} campos={campos} cabecera={cabecera} acciones={acciones} />
        </CardContent>
      </Card>
    </Page>
  );
}
